var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("vue-tags-input", {
        staticClass: "c-customer-select",
        attrs: {
          tags: _vm.customersSelected,
          "autocomplete-items": _vm.customers,
          "add-on-blur": false,
          "add-only-from-autocomplete": true,
          placeholder: _vm.$t("tours.headline.companysearch"),
          "max-tags": _vm.maxTags,
        },
        on: { "tags-changed": _vm.updateCustomers },
        scopedSlots: _vm._u([
          {
            key: "autocomplete-item",
            fn: function (props) {
              return _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      return props.performAdd(props.item)
                    },
                  },
                },
                [
                  _vm._v("\n      " + _vm._s(props.item.text) + "\n      "),
                  _c("small", [_vm._v("#" + _vm._s(props.item.id))]),
                  _vm._v(" "),
                  props.item.risk
                    ? [
                        props.item.risk.is_valid
                          ? _c("small", [
                              _vm._v(
                                _vm._s(_vm.$t("location.risk.risk_number")) +
                                  ": " +
                                  _vm._s(props.item.risk.risk_number)
                              ),
                            ])
                          : _c("small", { staticClass: "u-color--warning" }, [
                              _vm._v(_vm._s(_vm.$t("location.risk.not_valid"))),
                            ]),
                      ]
                    : _c("small", { staticClass: "u-color--warning" }, [
                        _vm._v(_vm._s(_vm.$t("location.risk.no_risk_number"))),
                      ]),
                ],
                2
              )
            },
          },
          {
            key: "tag-center",
            fn: function (props) {
              return _c(
                "div",
                {},
                [
                  _vm._v("\n        " + _vm._s(props.tag.text) + "\n        "),
                  props.tag.risk
                    ? [
                        _vm._v(
                          _vm._s(_vm.$t("location.risk.risk_number")) +
                            " " +
                            _vm._s(props.tag.risk.risk_number)
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            },
          },
        ]),
        model: {
          value: _vm.customerSearch,
          callback: function ($$v) {
            _vm.customerSearch = $$v
          },
          expression: "customerSearch",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }